import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

// AMRA AI Business OS product walkthrough (Google Drive embed).
// NOTE: the Drive file must be shared as "Anyone with the link" to play here.
const DEMO_VIDEO_EMBED =
  "https://drive.google.com/file/d/1-miyhXOad3tk6s24wtNUM53WGa5AIPYk/preview";

export const DemoModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="demo-modal"
        className="max-w-3xl overflow-hidden border-black/[0.06] p-0"
      >
        <DialogTitle className="sr-only">
          AMRA AI Business OS product walkthrough
        </DialogTitle>
        <DialogDescription className="sr-only">
          Watch the product demo video for AMRA AI Business OS.
        </DialogDescription>
        <div className="relative aspect-video w-full bg-black">
          <iframe
            data-testid="demo-video-iframe"
            src={DEMO_VIDEO_EMBED}
            title="AMRA AI Business OS product walkthrough"
            className="absolute inset-0 h-full w-full"
            allow="autoplay; encrypted-media; fullscreen"
            allowFullScreen
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DemoModal;
